import request from '@/utils/request'
import type { IP150PaddleItem } from '@/types/activity'

// p150赠送桨叶飞机列表
export function getUserActivityP150(): Promise<IP150PaddleItem[]> {
  return request.get(`/api/agri/users/activity/p150`)
}

// p150领取桨叶
export function receivingUserActivityP150(sn: string, serial_number: string) {
  return request.post(`/api/agri/users/activity/p150_receiving`, {
    sn,
    serial_number,
  })
}